import {
    createApp
} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import "element-plus/theme-chalk/index.css"
import "@/assets/css/page.css"

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app
    .use(store)
    .use(router)
    .use(ElementUI, {
        locale: zhCn,
    })
    .mount('#app')